import { supabase } from '../supabase/client';

export type NotificationModul = 'tickets' | 'rechnungen' | 'emails' | 'dokumente' | 'kalender' | 'system';

interface CreateNotificationParams {
  benutzerId: string;
  modul: NotificationModul;
  typ: string;
  nachricht: string;
  referenzId?: string;
  referenzTyp?: string;
  linkPfad?: string;
  erstelltVon?: string;
}

export async function createNotification(params: CreateNotificationParams): Promise<void> {
  const { error } = await supabase.from('benachrichtigungen').insert({
    benutzer_id: params.benutzerId,
    modul: params.modul,
    typ: params.typ,
    nachricht: params.nachricht,
    referenz_id: params.referenzId || null,
    referenz_typ: params.referenzTyp || null,
    link_pfad: params.linkPfad || null,
    erstellt_von: params.erstelltVon || null,
  });
  if (error) console.error('Notification fehlgeschlagen:', error);
}

export async function createNotifications(paramsList: CreateNotificationParams[]): Promise<void> {
  if (paramsList.length === 0) return;
  const { error } = await supabase.from('benachrichtigungen').insert(
    paramsList.map(p => ({
      benutzer_id: p.benutzerId,
      modul: p.modul,
      typ: p.typ,
      nachricht: p.nachricht,
      referenz_id: p.referenzId || null,
      referenz_typ: p.referenzTyp || null,
      link_pfad: p.linkPfad || null,
      erstellt_von: p.erstelltVon || null,
    }))
  );
  if (error) console.error('Notifications fehlgeschlagen:', error);
}
